import React from 'react';
import { LockKeyhole, ShieldCheck, Globe2 } from 'lucide-react';
import { Textarea } from '../ui/textarea';
import { Ticket } from '../../lib/types';
import { TriageSummary } from '../draft/TriageSummary';
import { GoogleSignInButton } from '../../auth/AuthControls';

export const DemoDraft = ({ticket}: {ticket: Ticket}) => <section className="draft-column">
  <div className="column-heading"><div><span className="step-number accent">02</span><h2 data-testid="demo-draft-heading">Your reply, a head start</h2></div><span className="demo-label" data-testid="demo-draft-label">EXAMPLE</span></div>
  <div className="draft-content">
    <TriageSummary ticket={ticket} saving onPatch={() => undefined}/>
    <div className="editor-label"><span data-testid="demo-reply-label">EXAMPLE REPLY</span><span data-testid="demo-reply-language"><Globe2 size={12}/>{ticket.language}</span></div>
    <Textarea className="draft-textarea" data-testid="demo-draft-textarea" aria-label="Read-only example reply" value={ticket.draft} readOnly/>
    <div className="demo-editor-footer"><span data-testid="demo-readonly-note"><LockKeyhole size={13}/>Read-only sample</span><GoogleSignInButton testId="demo-draft-sign-in"/></div>
    <div className="human-note"><ShieldCheck size={13}/><span data-testid="demo-safety-note">Real customer data stays private.</span></div>
  </div>
</section>;